export var NotificationType = {
  Email: 'Email',
  Candidate: 'Candidate',
  Texts: 'Texts',
  Authorisations: 'Authorisations',
  OnBoardingNotification: 'OnBoardingNotification'
}
